import React, { useState } from 'react';
import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import { adminLogout, adminName } from './auth';

const NAV = [
  { to: '/admin/content', label: 'Contenuti & Immagini' },
  { to: '/admin/gallery', label: 'Galleria & Sponsor' },
  { to: '/admin/tours', label: 'Tour & Prezzi' },
  { to: '/admin/slots', label: 'Disponibilità & Prenotazioni' },
  { to: '/admin/memberships', label: 'Iscrizioni & Tesseramenti' },
  { to: '/admin/proposals', label: 'Proposte date libere' },
  { to: '/admin/integrations', label: 'Integrazioni' },
];

const LOGO = '/img/INSOLITA_SARDEGNA_LOGO_MOTOCLUB-white.svg';

const AdminLayout: React.FC = () => {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const logout = () => { adminLogout(); navigate('/admin/login'); };

  return (
    <div className="min-h-screen md:flex bg-neutral-100 text-neutral-900">
      {/* Barra superiore mobile */}
      <div className="md:hidden flex items-center justify-between bg-[#0B0B0C] text-white px-4 h-14 sticky top-0 z-20">
        <img src={LOGO} alt="Insolita" className="h-8" />
        <button onClick={() => setOpen(true)} aria-label="Apri menu" className="p-2">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M3 6h18M3 12h18M3 18h18" /></svg>
        </button>
      </div>

      {/* Backdrop mobile */}
      {open && <div className="fixed inset-0 bg-black/50 z-30 md:hidden" onClick={() => setOpen(false)} />}

      {/* Sidebar */}
      <aside className={`fixed md:static inset-y-0 left-0 z-40 w-64 shrink-0 bg-[#0B0B0C] text-white flex flex-col transform transition-transform duration-300 md:translate-x-0 ${open ? 'translate-x-0' : '-translate-x-full'}`}>
        <div className="p-5 border-b border-white/10 flex items-center justify-between">
          <div>
            <img src={LOGO} alt="Insolita" className="h-10" />
            <p className="text-[#E4FF1A] text-[11px] uppercase tracking-widest mt-2">Dashboard</p>
          </div>
          <button onClick={() => setOpen(false)} aria-label="Chiudi menu" className="md:hidden text-white/70 p-1">
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M6 6l12 12M18 6L6 18" /></svg>
          </button>
        </div>
        <nav className="flex-1 p-3 space-y-1 overflow-y-auto">
          {NAV.map((n) => (
            <NavLink key={n.to} to={n.to} onClick={() => setOpen(false)}
              className={({ isActive }) =>
                `block px-4 py-2.5 rounded text-sm transition ${isActive ? 'bg-[#E4FF1A] text-[#0B0B0C] font-semibold' : 'text-white/75 hover:bg-white/10'}`
              }>
              {n.label}
            </NavLink>
          ))}
        </nav>
        <div className="p-4 border-t border-white/10">
          <p className="text-white/60 text-xs mb-2">{adminName()}</p>
          <button onClick={logout} className="text-sm text-white/80 hover:text-[#E4FF1A]">Esci →</button>
          <a href="/" target="_blank" rel="noreferrer" className="block mt-3 text-xs text-white/40 hover:text-white/70">Apri il sito ↗</a>
        </div>
      </aside>

      <main className="flex-1 min-w-0 overflow-x-auto">
        <div className="max-w-6xl mx-auto p-4 sm:p-8">
          <Outlet />
        </div>
      </main>
    </div>
  );
};

export default AdminLayout;
